import { render, staticRenderFns } from "./Sicon.vue?vue&type=template&id=31ad7634&scoped=true"
import script from "./Sicon.vue?vue&type=script&lang=js"
export * from "./Sicon.vue?vue&type=script&lang=js"
import style0 from "./Sicon.vue?vue&type=style&index=0&id=31ad7634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad7634",
  null
  
)

export default component.exports